import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ServiciosConsultasService } from "../../servicios/servicios-consultas.service";
import { ServiciosCalculosService } from "../../servicios/servicios-calculos.service";
import { CatConceptosService} from '../../servicios/cat-conceptos.service'
import { RegistraSolicitudesService } from "../../servicios/registra-solicitudes.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem } from "primeng/api";
import { ServiciosCalculos, ServiciosCalculosInput, EstadoCuentaInformacionInput, ServiciosCalculosTotales, ServiciosConsultasInput, ServiciosConsultas, PersonaClientes, Solicitudes, SolicitudDetalles, SolicitudesJson, AuxJasper, ParametroJasper, Aguas, BuscaTramite, EstadoCuentaInformacion, BuscaAsignaciones, CertificadoNoAdeudo, CertificadoNoAdeudoInput, RAguasPersonas, PropietarioRAguas, CatConceptos, ConceptosAdicionales, ConceptosAdicionalesInput } from '../../entidades/entidades';
import { AuthenticationService } from "app/servicios";
import { SolicitudDetallesService } from "../../servicios/solicitud-detalles.service";
import { EstadoCuentaInformacionService } from "../../servicios/estado-cuenta-informacion.service";
import { CertificadoNoAdeudoService } from "../../servicios/certificado-no-adeudo.service";
import { debounce } from "rxjs/operators";
import { PersonaClientesService } from "app/servicios/persona-clientes.service";
declare var $: any;

@Component({
  selector: "app-solicitud-detalles-grid",
  templateUrl: "./solicitud-detalles-grid.component.html",
  styleUrls: ["./solicitud-detalles-grid.component.css"],
})
export class SolicitudDetallesGridComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  serviciosCalculosInput: ServiciosCalculosInput;
  catConceptosPaquetesContratos: CatConceptos[] = [];
  selectedPaqueteContrato: any;

  serviciosCalculosTotales: ServiciosCalculosTotales;
  serviciosConsultas: ServiciosConsultas[];
  serviciosCalculos: ServiciosCalculos[];
  serviciosConsultasInput: ServiciosConsultasInput;
  cuentasSolicitantes: EstadoCuentaInformacion[] = [];//Arreglo que guarda las solicitudes trayendo al componente estado de cuenta
  conceptosAdicionales: ConceptosAdicionales[];

  tieneAdeudo: boolean = false;
  esCertificado: boolean = false;
  idRenglon: number;
  idConceptoSeleccionado: number;
  //datosSolicitud = new Solicitudes();
  observaciones: string;

  itemsMenu: MenuItem[];
  columnasTabla: any[];
  clonedServiciosConsultas: { [s: string]: ServiciosConsultas } = {};
  bloqueada: boolean;
  esDerivada: boolean = false;
  requiereCuenta: boolean = false;
  displayPaqueteContrato: boolean = false;

  public auxJasper: AuxJasper;
  display: boolean = false;
  showDialog() {
    this.display = true;
  }

  @Input("puedeSolicitar") puedeSolicitar: boolean;
  @Input("flagSolicitar")   flagSolicitar: boolean = false;
  public progressBar = false ;
  @Input("altaContrato")   altaContrato: boolean = false;
  @Input("esInfo")   esInfo: boolean = false;
  @Input("idSolicitud") idSolicitud: number;

  @Output() PropietarioOutput = new EventEmitter<{propietario: any, idAgua: number}>();

  @Output("solicitudOutput") solicitudOutput: EventEmitter<
    BuscaTramite
  >;
  @Output("aguasOutput") aguasOutput: EventEmitter<number>;
  

  solicitudEnviada: boolean = false;
  public idPersonaCliente: number;  //Se inyecta por medio de un ViewChild
  public idAgua: number;  //Se inyecta por medio de un ViewChild
  public aguas$ = new EventEmitter<Aguas>();

  constructor(
    private serviciosConsultasService: ServiciosConsultasService,
    private serviciosCalculosService: ServiciosCalculosService,
    private catConceptosService: CatConceptosService,
    private authenticationService: AuthenticationService,
    private registraSolicitudesService: RegistraSolicitudesService,
    private solicitudDetallesService: SolicitudDetallesService,
    private estadoCuentaInformacionService: EstadoCuentaInformacionService,
    private personaClientesService: PersonaClientesService,
    private certificadoNoAdeudoService: CertificadoNoAdeudoService
  ) {
    this.solicitudOutput = new EventEmitter();
    this.aguasOutput = new EventEmitter();
   }

  ngOnInit(): void {
    this.getAllCatConceptos();
    this.GetPaquetesContratos();

    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    
    if (this.altaContrato) {
      this.itemsMenu = [
        { label: "Agregar", icon: "pi pi-plus", command: () => this.add() },
        { label: "Paquete de contratos", icon: "pi pi-plus", command: () => this.showModal() }
      ];
    } else {
      this.itemsMenu = [
        { label: "Agregar", icon: "pi pi-plus", command: () => this.add() },
        //{ label: "Paquete de contratos", icon: "pi pi-plus", command: () => this.showModal() }
      ];
    }
    
    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore

      this.columnasTabla = [
        { field: "operacion", header: "", ordenar: false, styleHeader: "width: 30px;", },
        { field: "operacion", header: "", ordenar: false, styleHeader: "width: 30px;", },
        { field: "cuentaAgua", header: "Contrato", ordenar: true, styleHeader: "width: 70px;", },
        { field: "idConcepto", header: "Concepto", ordenar: true, styleHeader: "width: 250px;", },
        { field: "costoUnitario", header: "Costo Unitario", ordenar: false, styleHeader: "width: 80px;", },
        { field: "cantidad", header: "Cantidad", ordenar: false, styleHeader: "width: 50px;", },
        { field: "precio", header: "Precio", ordenar: false, styleHeader: "width: 50px;", },
        { field: "iva", header: "IVA", ordenar: false, styleHeader: "width: 50px;", },
        { field: "monto", header: "Monto", ordenar: false, styleHeader: "width: 80px;", },
      ];
    
  
    if (this.idSolicitud) { this.getAllServiciosConsultas(this.idSolicitud); }
    else { this.getAllServiciosConsultas(null); }
  }

  async ngOnChanges() {
    //console.log('Ya en el comoponenete', this.estadoCuentaInformacionInput)
    if (this.idSolicitud) {
      this.getAllServiciosConsultas(this.idSolicitud);
    }

  }

  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  // prettier-ignore
  add() {

    let id = Math.max(...this.serviciosConsultas.map((o) => o.id), 0) + 1;

    let serviciosConsultasNew = new ServiciosConsultas();
    serviciosConsultasNew.cambio = true;
    serviciosConsultasNew.descripcion = 'Seleccione un servicio...';
    serviciosConsultasNew.id = id;
    
    this.serviciosConsultas.push(serviciosConsultasNew);
    this.clonedServiciosConsultas[id] = { ...serviciosConsultasNew };
   
  }
  async showModal() {
    this.displayPaqueteContrato = true;
  }
  async hideModal() {
    this.displayPaqueteContrato = false;
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  // prettier-ignore
  onEditInit(event) {
    let serviciosConsultasEdit = event.data;
    serviciosConsultasEdit.cambio = true;
    serviciosConsultasEdit.baja = false;
  }

  // prettier-ignore
  onEditCancel(event) {
    let serviciosConsultasEdit = event.data;
    let index = this.serviciosConsultas.findIndex(
      (obj) => obj.id === serviciosConsultasEdit.id
    );
    
    this.serviciosConsultas[index] = { ...this.clonedServiciosConsultas[serviciosConsultasEdit.id] };
  }

  // prettier-ignore
  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
    this.cuentasSolicitantes.splice(index,1);
    this.serviciosConsultas = this.serviciosConsultas.filter(val => val.id !== event.id);
    this.CalculaTotales();
  }

  addCuenta(event, index: number) {
    this.idRenglon = event.id;

  }

  // prettier-ignore
  async onEditComplete(event) {
    try {
      let serviciosConsultasEdit = event.data;
      //buscamos el no_adeudo
      serviciosConsultasEdit.noAdeudo = this.serviciosCalculos.find(x =>  x.id ==  serviciosConsultasEdit.idConcepto)?.noAdeudo;
      //Valida si hay cambios
      if (
        serviciosConsultasEdit.cantidad === this.clonedServiciosConsultas[serviciosConsultasEdit.id].cantidad &&
        serviciosConsultasEdit.idConcepto === this.clonedServiciosConsultas[serviciosConsultasEdit.id].idConcepto &&
        serviciosConsultasEdit.cuentaAgua === this.clonedServiciosConsultas[serviciosConsultasEdit.id].cuentaAgua && 
        serviciosConsultasEdit.costo === this.clonedServiciosConsultas[serviciosConsultasEdit.id].costo
      ) {
        // let index = this.serviciosConsultas.findIndex((obj) => obj.id === serviciosConsultasEdit.id);
        // this.serviciosConsultas[index] = { ...this.clonedServiciosConsultas[serviciosConsultasEdit.id] };
        return;
      }

      serviciosConsultasEdit.cambio = true;
      serviciosConsultasEdit.baja = false;
      

      let serviciosCalculosSeleccionado = new ServiciosCalculos();
      serviciosCalculosSeleccionado = this.serviciosCalculos.filter((x) => x.id == serviciosConsultasEdit.idConcepto)[0];

      if (serviciosConsultasEdit.idConcepto !== this.clonedServiciosConsultas[serviciosConsultasEdit.id].idConcepto) {
        serviciosConsultasEdit.descripcion = serviciosCalculosSeleccionado.label;
        serviciosConsultasEdit.costo = serviciosCalculosSeleccionado.costo;
        serviciosConsultasEdit.cantidad = serviciosCalculosSeleccionado.cantidad;
        serviciosConsultasEdit.precio = serviciosCalculosSeleccionado.precio;
        serviciosConsultasEdit.iva = serviciosCalculosSeleccionado.iva;
        serviciosConsultasEdit.monto = serviciosCalculosSeleccionado.monto;
        this.clonedServiciosConsultas[serviciosConsultasEdit.id].idConcepto = serviciosCalculosSeleccionado.id;
      }
      
      //Realiza la consulta del calculo 
      if (serviciosConsultasEdit.costo !== this.clonedServiciosConsultas[serviciosConsultasEdit.id].costo)
      {
        
        let serviciosCalculosInput = new ServiciosCalculosInput();
        serviciosCalculosInput.idConcepto = serviciosConsultasEdit.idConcepto;
        serviciosCalculosInput.cantidad = serviciosConsultasEdit.cantidad;
        serviciosCalculosInput.MontoEditable = serviciosConsultasEdit.costo;

        let serviciosCalculosRetornado: ServiciosCalculos[];
        serviciosCalculosRetornado    = await this.getCatConceptos(serviciosCalculosInput);
        serviciosConsultasEdit.precio = serviciosCalculosRetornado[0].precio;
        serviciosConsultasEdit.iva    = serviciosCalculosRetornado[0].iva;
        serviciosConsultasEdit.monto  = serviciosCalculosRetornado[0].monto;
        serviciosConsultasEdit.costo  = serviciosCalculosRetornado[0].costo;
      }  
    
      
      this.CalculaTotales();
      
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }

  CalculaTotales() {
    this.serviciosCalculosTotales = new ServiciosCalculosTotales();
    //this.serviciosCalculosTotales.monto = 0;

    for (var i = 0, len = this.serviciosConsultas.length; i < len; ++i) {
      this.serviciosCalculosTotales.monto = this.serviciosCalculosTotales.monto + this.serviciosConsultas[i].monto;
    }
  }

  // prettier-ignore
  async getAllServiciosConsultas(idSolicitud: number) {

    try {
      this.serviciosConsultasInput = new ServiciosConsultasInput();
      this.serviciosConsultasInput.idSolicitud = idSolicitud;
      const datoRetorno = await this.serviciosConsultasService.getBusquedas(this.serviciosConsultasInput).toPromise();
      this.serviciosConsultas = datoRetorno;
    
      var flagCuenta = true;
        
      for (var i = 0, len = this.serviciosConsultas.length; i < len; ++i)
      {
         this.clonedServiciosConsultas[this.serviciosConsultas[i].id] = { ...this.serviciosConsultas[i], };
      }

     if(this.puedeSolicitar == true)
        {
          this.add()
        }

        
        // Acomoda de 
        //let serviciosConsultasInvert = this.serviciosConsultas.reverse();
        // Busca el propietario de la cuenta del ultimo detalle

        for (let index = 0;  index < this.serviciosConsultas.length; index++) {
          if (this.serviciosConsultas[index].idAgua) {
              flagCuenta = false;
              await this.EnviaIdAgua(this.serviciosConsultas[index].idAgua);
              break;    
          }  
        }

      if(flagCuenta)  await this.EnviaIdAgua(null);

      this.CalculaTotales();

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por ignore");
    }
  }
  async onPaqueteContratoChange(event: any) {
    try{
      if (!event.value || !event.value.id) {return;}

      this.displayPaqueteContrato = false;
      let cai = new ConceptosAdicionalesInput();
      cai.idConceptoPrincipal = event.value.id;
      const datoRetorno = await this.serviciosConsultasService.postConceptosAdicionales(cai).toPromise();
      this.conceptosAdicionales = datoRetorno;

      for (let i = 0; i < this.conceptosAdicionales.length; i++) {
        //Crear nuevo registro vacio
        let serviciosCalculosSeleccionado = new ServiciosCalculos();
        serviciosCalculosSeleccionado = this.serviciosCalculos.filter((x) => x.id == this.conceptosAdicionales[i].id)[0];

        let id = Math.max(...this.serviciosConsultas.map((o) => o.id), 0) + 1;
        let serviciosConsultasNew = new ServiciosConsultas();
        serviciosConsultasNew.cambio = true;
        serviciosConsultasNew.descripcion = serviciosCalculosSeleccionado.label;
        serviciosConsultasNew.id = id;
        serviciosConsultasNew.costo = serviciosCalculosSeleccionado.costo;
        serviciosConsultasNew.cantidad = serviciosCalculosSeleccionado.cantidad;
        serviciosConsultasNew.precio = serviciosCalculosSeleccionado.precio;
        serviciosConsultasNew.iva = serviciosCalculosSeleccionado.iva;
        serviciosConsultasNew.monto = serviciosCalculosSeleccionado.monto;
        serviciosConsultasNew.idConcepto =  this.conceptosAdicionales[i].id;
        this.serviciosConsultas.push(serviciosConsultasNew);
        this.clonedServiciosConsultas[id] = { ...serviciosConsultasNew };
        this.CalculaTotales();
      
    }
    
    }catch(e){
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por onPaqueteContratoChange");
    }
  }

  // prettier-ignore
  async getAllCatConceptos() {
    try {
      let serviciosCalculosInput = new ServiciosCalculosInput();
      serviciosCalculosInput.idConcepto = null;
      serviciosCalculosInput.idGrupoConcepto = 1;
      this.serviciosCalculos = null;

      const datoRetorno = await this.serviciosCalculosService.getBusquedas(serviciosCalculosInput).toPromise();
      this.serviciosCalculos = datoRetorno;

      let serviciosCalculosNew = new ServiciosCalculos();
      serviciosCalculosNew.label = "Seleccionar...";
      serviciosCalculosNew.value = null;
      this.serviciosCalculos.unshift(serviciosCalculosNew);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCatConceptos");
    }
  }
  async GetPaquetesContratos(){
    try{
        const datoRetorno = await this.catConceptosService.getPaqueteContratos().toPromise();
        this.catConceptosPaquetesContratos = datoRetorno;
    }catch(e){
      throw e;
    } 
  }
  // prettier-ignore
  async getCatConceptos(serviciosCalculosInput) {
    try {
      const datoRetorno = await this.serviciosCalculosService.getBusquedas(serviciosCalculosInput).toPromise();
      return datoRetorno;

    }catch(e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatConceptos");
    }
  }

  // prettier-ignore
  async guardaSolicitudTramtie(){
    try {
      this.progressBar = true;
      await this.editaDetalleSolicitud(this.idSolicitud);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por guardaSolicitudTramtie");
      this.progressBar = false;
    }

  }

  // prettier-ignore
  async guardaSolicitud() {
    try 
    {
      this.tieneAdeudo = false;
      this.bloqueada = false;
      this.requiereCuenta = false;

      if (this.serviciosConsultas[0].idConcepto == null) {
        this.muestraMensaje.warning("Selecciona al menos un servicio", "top", "center");
        return;
      }

      //Registro Solicitudes
      if (this.idPersonaCliente == null) {
        this.muestraMensaje.warning("Selecciona un solicitante", "top", "center");
        return;
      }

      if(this.serviciosConsultas[0].idConcepto == 1527 && this.serviciosConsultas[0].cuentaAgua == null){
        this.muestraMensaje.warning("Ingrese una cuenta.", "top", "center");
        return;
      }

      //CONSULTA SI EL SERVICIO REQUIERE CUENTA Y CONSULTA SI LA CUENTA CUENTA CON ADEUDO
      let retorno = new CertificadoNoAdeudo();
      for(var i = 0; i < this.serviciosConsultas.length; i++)
      {
        let busqueda = new CertificadoNoAdeudoInput;
        busqueda.idAgua = this.serviciosConsultas[i].idAgua;
        if((this.serviciosConsultas[i].idConcepto == 1 || this.serviciosConsultas[i].idConcepto == 2 || this.serviciosConsultas[i].idConcepto == 3 || this.serviciosConsultas[i].idConcepto == 4) && this.esDerivada == true)
        {
          this.requiereCuenta = false;
          this.muestraMensaje.error("Una cuenta Derivada no puede realizar una apertura  de cuenta.", "top", "center");
          return;
        }
        else if((this.serviciosConsultas[i].idConcepto == 1 || this.serviciosConsultas[i].idConcepto == 2 || this.serviciosConsultas[i].idConcepto == 3 || this.serviciosConsultas[i].idConcepto == 4) && this.esDerivada == false)
        {
          this.requiereCuenta = false;
        } 
        if(this.serviciosConsultas[i].idConcepto == 9 || this.serviciosConsultas[i].idConcepto == 10 || this.serviciosConsultas[i].idConcepto == 11 || this.serviciosConsultas[i].noAdeudo) 
        {
          if(this.serviciosConsultas[i].idAgua != null)
          {
            retorno =  await this.certificadoNoAdeudoService.getBusquedas(busqueda).toPromise();
          }
          else
          {
            this.muestraMensaje.warning(
              "El trámite: " + this.serviciosConsultas[0].descripcion + " no se puede solicitar sin un contrato de agua.",
              "top",
              "center"
            );            
            return;
          }
          
          
          if(!retorno[0])
          {
            this.tieneAdeudo = true;
          }

        }
  
      //Validar si el servicio ocupa que no tenga uno en proceso
      var requiereEditable = this.serviciosConsultas.some(e => {
        return this.serviciosCalculos.some(sc => {
              if (sc.noEditable) {
                return true; // Indica que se encontró un servicio con un proceso previo
            }
            return false;
        });
      });
      if (requiereEditable) {
        this.serviciosConsultasInput = new ServiciosConsultasInput();
        this.serviciosConsultasInput.idSolicitud =null;
        this.serviciosConsultasInput.idAgua = this.serviciosConsultas[i].idAgua;
        const datoRetorno = await this.serviciosConsultasService.getBusquedas(this.serviciosConsultasInput).toPromise();
        
        if(Object.keys(datoRetorno).length > 0)
        {
          this.muestraMensaje.warning("La cuenta tiene un proceso ", "top", "center");
        return;
        }

      }
      
      }

      let servicioConError = "";

      this.requiereCuenta = this.serviciosConsultas.some(e => {
          return this.serviciosCalculos.some(sc => {
                if (sc.id === e.idConcepto && sc.reqContrato === true && (e.cuentaAgua === null || e.cuentaAgua === undefined)) {
                  servicioConError = sc.label; // Almacena la descripción del servicio con error
                  return true; // Indica que se encontró un servicio con error
              }
              return false;
          });
      });
      if (this.requiereCuenta) {
        this.muestraMensaje.warning("Selecciona una Cuenta Agua al servicio: " + servicioConError, "top", "center");
        return;
      }

      

      // Validar si todas las cuentas de agua son iguales
      const cuentasUnicas = new Set();

      this.serviciosConsultas.forEach(e => {
          if (e.cuentaAgua !== null && e.cuentaAgua !== undefined) {
              cuentasUnicas.add(e.cuentaAgua);
          }
      });
      // Si hay más de una cuenta única, significa que son diferentes
      if (cuentasUnicas.size > 1) {
          this.muestraMensaje.warning("Las cuentas de agua deben ser iguales en todos los servicios.", "top", "center");
          return;
      }
            

      /* Recorre cada solicitud guardada en el arreglo */
      let newCuenta = new EstadoCuentaInformacion;
      this.cuentasSolicitantes.forEach((e) => {
        newCuenta = e;
        if(e[0].bloqueoVigente != null || e[0].estatus == "CANCELADO")
        {
          this.bloqueada = true;
        }    
        else 
        this.bloqueada = false;
      });  
      this.serviciosConsultas.forEach((e) => {
        for(var i = 0; i < this.serviciosCalculos.length; i++)
        {
          if(e.idConcepto == 139)
          {
            this.bloqueada = false;
          }    
         
        }
      });

      /* Despues de la validacion, se muestra un mensaje indicando que la cuenta esta bloqueada */
      
      if(this.bloqueada){
        this.muestraMensaje.warning("Una de las cuentas está bloqueda o cancelada.", "top", "center");
        this.muestraMensaje.warning("No se pueden generar solicitudes para esa cuenta.", "top", "center");
        /* this.muestraMensaje.error("Elimine el servicio bloqueado y genere uno nuevo para continuar .", "top", "center"); */
        return;
      }
      if (this.tieneAdeudo) {
        this.muestraMensaje.warning(
          `El contrato presenta adeudos pendientes. No es posible solicitar el trámite "${this.serviciosConsultas[0].descripcion}".`,
          "top",
          "center"
        );     
        return;
      }

      let solicitudesJson = new SolicitudesJson();

      //Agrega datos de la solicitud
      solicitudesJson.solicitudes.idUsuarioSolicito = this.authenticationService.currentUserValue.id;
      solicitudesJson.solicitudes.idPersonaCliente  = this.idPersonaCliente;
      solicitudesJson.solicitudes.idConcepto        = this.serviciosConsultas[0].idConcepto;
      solicitudesJson.solicitudes.idAgua = this.idAgua;
      solicitudesJson.solicitudes.observaciones = this.observaciones;

      //Agrega los conceptos a solicitar
      let solicitudDetalles = new SolicitudDetalles();
      for (var i = 0, len = this.serviciosConsultas.length; i < len; ++i) {
        solicitudDetalles = new SolicitudDetalles();
        solicitudDetalles.idConcepto    = this.serviciosConsultas[i].idConcepto;
        solicitudDetalles.cantidad      = this.serviciosConsultas[i].cantidad;
        solicitudDetalles.idAgua        = this.serviciosConsultas[i].idAgua;
        solicitudDetalles.costoUnitario = this.serviciosConsultas[i].costo;
        solicitudesJson.solicitudDetalles.push(solicitudDetalles);
      }

      const datoRetorno = await this.registraSolicitudesService.getBusquedas(solicitudesJson).toPromise();
      let solicitudes = new Solicitudes();
      solicitudes = datoRetorno;

      await this.imprimeSolicitud(solicitudes[0].id);
      await this.limpiaGrid();

      // despues de guardar la solicitud se emite un id 0 que se retomara en un componente de ventanilla 
      //la busqueda del solicitante default
      let newSolicitud=new BuscaTramite;
      newSolicitud.id=0;
      await this.solicitudOutput.emit(newSolicitud);

      this.solicitudEnviada = true;
      /* Limpia el arreglo despues que se guardó */
      this.cuentasSolicitantes = [];
    } catch (error) {
      throw error;
    } finally {
    }
  }
  async editaDetalleSolicitud(idSolicitud:number){
    try{
      let solicitudesJson = new SolicitudesJson();
      solicitudesJson.solicitudes.id = idSolicitud; 
      //Agrega los conceptos a solicitar
      let solicitudDetalles = new SolicitudDetalles();
      for (var i = 0, len = this.serviciosConsultas.length; i < len; ++i) {
        solicitudDetalles = new SolicitudDetalles();
        solicitudDetalles.id = this.serviciosConsultas[i].id;
        solicitudDetalles.idConcepto    = this.serviciosConsultas[i].idConcepto;
        solicitudDetalles.cantidad      = this.serviciosConsultas[i].cantidad;
        solicitudDetalles.idAgua        = this.serviciosConsultas[i].idAgua;
        solicitudDetalles.costoUnitario = this.serviciosConsultas[i].precio;
        solicitudDetalles.cambio        = this.serviciosConsultas[i].cambio;
        solicitudesJson.solicitudDetalles.push(solicitudDetalles);
      }
      const datoRetorno = await this.registraSolicitudesService.postEditaDetalleSolicitud(solicitudesJson).toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por editaDetalleSolicitud");
    }
  }

  async selectRow(row: any) {
    try 
    {
      if(this.flagSolicitar) return;
      let solicitudDetalle = new BuscaTramite();
      solicitudDetalle = row;
      solicitudDetalle.concepto = row.descripcion;
      this.solicitudOutput.emit(solicitudDetalle);

      //Guarda en una variable el Concepto Seleccionado
      this.idConceptoSeleccionado = row.idConcepto;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {

      console.log("Paso por getBuscaTramite");
    }
  }
 
  async buscaAdeudo(cuentaAgua : number)
  {
      let adeudo = false;
      let busqueda = new CertificadoNoAdeudoInput;
      busqueda.cuentaAgua = cuentaAgua;

      const datoRetorno =  await this.certificadoNoAdeudoService.getBusquedas(busqueda).toPromise();

      if(!datoRetorno)
      {
        adeudo = true;
      }
      return adeudo;
  }

  async limpiaGrid()
  {
    try 
    {
      this.serviciosConsultas = null;
      this.serviciosConsultasInput = new ServiciosConsultasInput();
      this.serviciosConsultasInput.idSolicitud = 0;
      const datoRetorno = await this.serviciosConsultasService.getBusquedas(this.serviciosConsultasInput).toPromise();
      this.serviciosConsultas = datoRetorno;
      

      for (var i = 0, len = this.serviciosConsultas.length; i < len; ++i)
        this.clonedServiciosConsultas[this.serviciosConsultas[i].id] = { ...this.serviciosConsultas[i], };
      
        if(this.puedeSolicitar == true)
        {
          this.add()
        
        }

      this.CalculaTotales();
      
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por ignore");
    }
  }

  async imprimeSolicitud(idSolicitud) {
    this.auxJasper = new AuxJasper();
    this.auxJasper.JasperReport.nombreReporte = "Solicitud";
    this.auxJasper.JasperReport.tipo = "pdf";
    const parametroJasper = new ParametroJasper();
    parametroJasper.nombre = "_id_solicitud";
    parametroJasper.valor = idSolicitud + "";
    const withCopy = new ParametroJasper();
    withCopy.nombre = "withCopy";
    withCopy.valor = "wCopy";
    await this.auxJasper.ParametroJasper.push(parametroJasper);
    await this.auxJasper.ParametroJasper.push(withCopy);
    await this.showDialog();

    this.aguasOutput.emit(null);
  }


  async childAguaBuscaCuentasGrid(idAgua: number) 
  {
    try 
      {
        //Carga formulario estado-cuentas
        let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
        estadoCuentaInformacionInput.idAgua = idAgua;
        
        const datoRetorno = await this.estadoCuentaInformacionService.getBusquedas(estadoCuentaInformacionInput).toPromise();
        let estadoCuenta = new EstadoCuentaInformacion();
        estadoCuenta = datoRetorno;
        this.cuentasSolicitantes.push(datoRetorno);

        if(this.puedeSolicitar == true)
        {
          if(datoRetorno[0].derivada != 0)
          {
            this.esDerivada = true;
          }else{
            this.esDerivada = false;
          }
        }else{
          if((this.idConceptoSeleccionado == 1 ||this.idConceptoSeleccionado == 2 || this.idConceptoSeleccionado == 3|| this.idConceptoSeleccionado == 4) && datoRetorno[0].derivada != 0)
          {
            this.muestraMensaje.error("No puedes seleccionar una Derivada para una apertura.", "top", "center");
            return;
          }
        }

        /* Validacion que muestra un mensaje cuando la cuenta esta bloqueada */
        if (datoRetorno[0].bloqueoVigente != null) {
          datoRetorno[0].derivada
          this.muestraMensaje.error("Esta cuenta está bloqueada", "top", "center");
        }
        /* Validacion que muestra un mensaje cuando la cuenta esta cancelada */
        else if (datoRetorno[0].estatus == "CANCELADO") {
          this.muestraMensaje.error("Esta cuenta está cancelada", "top", "center");
        }

        $("#mAguas").modal('hide')
        if (idAgua) 
        {
          for (var i = 0, len = this.serviciosConsultas.length; i < len; ++i) {
            if(this.idRenglon == this.serviciosConsultas[i].id)
            {
              this.serviciosConsultas[i].cuentaAgua = null;//aguas.cuentaAgua;
              this.serviciosConsultas[i].idAgua = idAgua;
            }
          }
        }
        if(this.idSolicitud != null)
        {
          
            let solicitudActualizada = new SolicitudDetalles;  
            solicitudActualizada.idAgua = idAgua;
            solicitudActualizada.id = this.idRenglon;
            const datoRetorno = await this.solicitudDetallesService
              .actualiza(solicitudActualizada)
              .toPromise();
        }

        this.aguasOutput.emit(idAgua);




    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateMedidores");
    }
  }

  async EnviaIdAgua(idAgua : number){
    if(idAgua == null) 
    {
      this.PropietarioOutput.emit({propietario: null, idAgua: null});
    }
    else 
    {
      const datoRetorno = await this.serviciosConsultasService.getPropietario(idAgua).toPromise();
      // Emitir el evento
      this.PropietarioOutput.emit({propietario: datoRetorno, idAgua: idAgua});
    }


  }

}